import { Dialog, DialogContent, DialogTitle } from "@mui/material"
import UtilFunctions, { Transition } from "../Utils/UtilFucntion"
import InputValidate from "./InputValidate"
import { LoadingButton } from "@mui/lab"
import SendAndArchiveRoundedIcon from '@mui/icons-material/SendAndArchiveRounded';
import { useState } from "react";

type props = {
    show: boolean,
    setShow: Function
}

type PassWordForm = {
    oldPass: string,
    newPass: string,
    confirmPass: string
}
export default function ChangePassword({ show, setShow }: props) {
    const [dataForm, setDataForm] = useState<PassWordForm>({ oldPass: '', newPass: '', confirmPass: '' });
    function onChangeData(field: string, value: string) {
        setDataForm({ ...dataForm, [field]: value });
    }

    function onSubmit(): void {

    }
    return (
        <Dialog
            open={show}
            onClose={() => setShow(false)}
            fullWidth
            maxWidth='xs'
            TransitionComponent={Transition}
        >
            <DialogTitle>
                <div className="text-[#0d47a1]">Đổi mật khẩu</div>
            </DialogTitle>
            <DialogContent>
                <div className="mt-2">
                    <InputValidate label={"Mật khẩu cũ"} name={"oldPass"} onChangeData={onChangeData}
                        value={dataForm.oldPass} isValid={UtilFunctions.isValidPassword(dataForm.oldPass)} alert={"Mật khẩu phải lớn hơn 8 ký tự"}
                        disabled={false} placeholder={"Mật khẩu cũ"} type={"password"} />
                </div>
                <div className="mt-8">
                    <InputValidate label={"Mật khẩu mới"} name={"newPass"} onChangeData={onChangeData}
                        value={dataForm.newPass} isValid={UtilFunctions.isValidPassword(dataForm.newPass)} alert={"Mật khẩu phải lớn hơn 8 ký tự"}
                        disabled={false} placeholder={"Mật khẩu cũ"} type={"password"} />
                </div>
                <div className="mt-8">
                    <InputValidate label={"Xác nhận mật khẩu mới"} name={"confirmPass"} onChangeData={onChangeData}
                        value={dataForm.confirmPass} isValid={UtilFunctions.isValidPassword(dataForm.confirmPass)} alert={"Mật khẩu phải lớn hơn 8 ký tự"}
                        disabled={false} placeholder={"Xác nhận"} type={"password"} />
                </div>
            </DialogContent>
            <div className="p-4 flex justify-end">
                <LoadingButton
                    loadingPosition="start"
                    variant="contained"
                    startIcon={<SendAndArchiveRoundedIcon />}
                    onClick={onSubmit}
                >
                    Cập nhật
                </LoadingButton>
            </div>
        </Dialog>
    )
}